const ListPaymentDetail = {
  Tooltip: {
    title: 'Essa infração tinha um desconto disponível, mas ele não foi aplicado no pagamento.'
  }
};

export default ListPaymentDetail;
